var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"victoria-brand",class:{ 'victoria-brand--compact': _vm.compact }},[_c('img',{staticClass:"victoria-brand__logo",attrs:{"src":_vm.$brand.logo,"alt":_vm.$brand.name + ' logo'}})])}
var staticRenderFns = []

export { render, staticRenderFns }